{
  "greeting": {
    "salam": "Assalamualaikum",
    "salamWithName": "Assalamualaikum, {{name}}"
  },
  "dock": {
    "saved": "Tersimpan",
    "savedVerses": "Ayat tersimpan",
    "tasks": "Tugas",
    "notes": "Catatan"
  },
  "actions": {
    "save": "Simpan",
    "cancel": "Batal",
    "close": "Tutup",
    "delete": "Hapus",
    "rename": "Ganti nama",
    "dismiss": "Tutup",
    "loading": "Memuat…",
    "reload": "Muat ulang",
    "retry": "Coba lagi",
    "expand": "Perluas",
    "collapse": "Ciutkan"
  },
  "nav": {
    "appNavigation_aria": "Navigasi aplikasi"
  },
  "tabs": {
    "home": "Beranda",
    "tasks": "Tugas",
    "notes": "Catatan",
    "more": "Lainnya"
  },
  "more": {
    "daily": "Harian",
    "account": "Akun",
    "savedVerses": "Ayat tersimpan",
    "qibla": "Kiblat",
    "prayerTimes": "Waktu Salat & Pengingat",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Dikelola melalui akun Rhemn Anda",
    "upgrade": "Tingkatkan",
    "privacyPolicy": "Kebijakan Privasi",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Kembali",
    "deleteAccount": "Hapus akun"
  },
  "reflection": {
    "dismiss_aria": "Tutup refleksi"
  },
  "app": {
    "loading_aria": "Rhemn sedang memuat",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Kelola langganan Rhemn Pro Anda di web. Pro terbuka otomatis di sini saat Anda masuk dengan akun langganan Anda."
  },
  "header": {
    "qiblaDirection_aria": "Arah kiblat",
    "prayerTimes_aria": "Waktu salat",
    "prayerTimesTitle": "Waktu Salat",
    "method": "Metode",
    "methodHelp": "Metode memengaruhi waktu yang dihitung"
  },
  "search": {
    "search_aria": "Cari",
    "searchLabel": "Cari",
    "searchWeb_placeholder": "Cari di web"
  },
  "focus": {
    "input_placeholder": "Apa yang paling penting hari ini?",
    "example_worship": "Shalat dengan khusyuk, tanpa terburu-buru",
    "example_kindness": "Menelepon ibu hanya untuk mendengarkannya",
    "example_reflect": "Renungkan niatmu bersama ayat hari ini",
    "saveIntention_aria": "Simpan niat",
    "celebration": "🤲 Masyaallah"
  },
  "profile": {
    "profileFallback": "Profil",
    "profileAndAccount_aria": "Profil dan akun",
    "profileDialog_aria": "Profil",
    "editName_aria": "Ubah nama Anda",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Kelola langganan",
    "manageSubscription_aria": "Kelola langganan Rehmn Pro Anda",
    "anonymousAnalytics": "Analitik anonim",
    "anonymousAnalyticsNote": "Hanya agregat — tidak pernah dikaitkan dengan Anda",
    "shareAnalytics_aria": "Bagikan analitik penggunaan anonim",
    "signOut": "Keluar",
    "signingOut": "Sedang keluar…",
    "signOut_aria": "Keluar dari Rehmn",
    "restorePurchases": "Pulihkan pembelian",
    "restorePurchases_aria": "Pulihkan pembelian sebelumnya"
  },
  "background": {
    "loading": "Memuat latar belakang...",
    "fallbackNotice": "Menggunakan gambar cadangan (API Unsplash tidak tersedia)",
    "noImage": "Tidak ada gambar latar belakang",
    "error": "Galat: {{message}}",
    "photoByOnUnsplash": "Foto oleh <photographer>{{name}}</photographer> di <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Terjadi kesalahan",
    "fallbackMessage": "Terjadi galat yang tidak terduga."
  },
  "theme": {
    "switchToLight_title": "Beralih ke mode terang",
    "switchToDark_title": "Beralih ke mode gelap"
  },
  "upgradeCta": {
    "upgradeToPro": "Tingkatkan ke Pro",
    "restorePurchases": "Pulihkan pembelian",
    "restoring": "Memulihkan…",
    "restoreEmpty": "Tidak ada pembelian ditemukan.",
    "pricePerMonth": "{{price}} / bulan",
    "pricePerYear": "{{price}} / tahun",
    "purchasePending": "Menunggu persetujuan. Pro akan aktif secara otomatis setelah pembelian disetujui.",
    "storeUnavailable": "App Store tidak dapat dijangkau saat ini. Coba lagi sebentar lagi.",
    "purchaseFailed": "Pembelian tidak dapat diselesaikan. Coba lagi sebentar lagi."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · Hemat 25% di tahun pertama",
    "title": "Untuk jam-jam di antara salatmu.",
    "body": "Catatan suara yang ditranskripsi, diringkas, dan menjadi tugas. Perencana hari yang disusun mengikuti jadwal salatmu. Catatan dengan AI.",
    "price": "$29.99",
    "period": "untuk tahun pertama",
    "priceIos": "Hemat 25% di tahun pertama",
    "terms": "Selanjutnya $39.99 per tahun. Kode {{code}} sudah diterapkan untukmu.",
    "termsIos": "Diperpanjang dengan harga tahunan biasa. Gunakan kode {{code}} di App Store.",
    "free": "Jadwal salat, kiblat, ayat harian, dan tugas tetap gratis.",
    "cta": "Tingkatkan ke Pro",
    "dismiss": "Nanti saja"
  },
  "planChooser": {
    "monthly": "Bulanan",
    "yearly": "Tahunan",
    "yearlyValue": "Empat bulan dari kami.",
    "freeNote": "Jadwal salat, Kiblat, ayat harian, dan tugas gratis. Rhemn Pro menambahkan:",
    "includes_planner": "Rencana hari yang disusun di sekitar lima waktu salat, dan “Rencanakan hari saya”",
    "includes_insights": "Quran Insights — tanyakan apa pun tentang sebuah ayat dan baca konteksnya",
    "includes_reflections": "Renungan ayat harian, ditulis untuk niat yang Anda tetapkan",
    "includes_notes": "Catatan dan catatan suara, dengan rangkuman dan perapian AI",
    "includes_extras": "Ayat tersimpan, kartu ayat, runtutan hari, dan prakiraan 5 hari",
    "renewsMonthly": "Diperpanjang setiap bulan hingga dibatalkan",
    "renewsYearly": "Diperpanjang setiap 12 bulan hingga dibatalkan",
    "continue": "Lanjutkan",
    "renewalTerms": "Pembayaran ditagihkan ke Apple ID Anda saat konfirmasi. Langganan diperpanjang otomatis kecuali perpanjangan otomatis dimatikan setidaknya 24 jam sebelum periode berakhir. Kelola atau batalkan kapan saja di pengaturan Apple ID.",
    "retry": "Coba lagi"
  },
  "streak": {
    "badge_aria": "Istiqamah harian — {{count}} hari",
    "title": "Istiqamah harian",
    "daysWithCount": "Istiqamah {{count}} hari",
    "start": "Mulai hari ini — luangkan sejenak bersama ayat atau tandai salat.",
    "prayedToday": "Sudah salat hari ini",
    "readVerse": "Sudah membaca ayat hari ini",
    "autoHint": "Ayat tertandai dengan sendirinya saat Anda meluangkan sejenak bersamanya.",
    "milestoneTitle": "{{count}} hari dengan niat",
    "milestoneBody": "Alhamdulillah. Bagikan pencapaian ini — orang yang Anda sayangi mungkin ikut memulai.",
    "share": "Bagikan",
    "dismiss": "Nanti saja",
    "cardLabel": "hari dengan niat",
    "shareCaption": "{{count}} hari memulai dengan niat — rhemn.com",
    "imageSaved": "Gambar tersimpan.",
    "couldNotCreateImage": "Tidak dapat membuat gambar. Silakan coba lagi."
  },
  "qibla": {
    "compassIcon_aria": "Ikon kompas",
    "title": "Arah Kiblat",
    "locationUnavailable": "Lokasi tidak tersedia",
    "locating": "Mencari lokasi…",
    "compass_aria": "Kompas kiblat",
    "directionN": "U",
    "directionE": "T",
    "directionS": "S",
    "directionW": "B",
    "facingQibla": "Menghadap Kiblat",
    "enableLiveCompass": "Aktifkan Kompas Langsung",
    "enableLiveCompassNote": "Menggunakan sensor gerak agar panah mengikuti saat Anda berputar — bukan lokasi",
    "directionToMecca": "Arah ke Mekah",
    "enableLocation": "Aktifkan akses lokasi untuk menghitung arah",
    "hintLive": "Panah melacak orientasi perangkat Anda secara waktu nyata",
    "hintStatic": "Sudut dari Utara — gunakan dengan kompas untuk arah yang akurat",
    "live": "Langsung",
    "footerVerse": "\"Palingkanlah mukamu ke arah Masjidil Haram\" – Quran 2:144"
  },
  "legal": {
    "links_aria": "Legal",
    "termsOfUse": "Ketentuan Penggunaan",
    "privacyPolicy": "Kebijakan Privasi"
  },
  "auth": {
    "signInForPro": "Masuk dulu — Pro Anda ikut ke mana saja."
  },
  "integrations": {
    "row": {
      "label": "Kalender & tugas",
      "caption": "Tersambung",
      "subNone": "Belum tersambung",
      "subFree": "Google Calendar, Google Tasks, dan lainnya",
      "subAttention": "{{provider}} perlu perhatian",
      "subPaused": "Sinkronisasi dijeda"
    },
    "list": {
      "title": "Kalender & tugas",
      "subtitle": "Bawa rapat dan daftar tugasmu ke dalam harimu.",
      "footnote": "Rhemn hanya membaca yang diperlukan, dan tidak pernah menyimpan acaramu.",
      "privacy": "Kebijakan Privasi",
      "connect": "Sambungkan",
      "connect_aria": "Sambungkan {{what}}",
      "checking": "Memeriksa…",
      "loadError": "Koneksi Anda tidak dapat dimuat.",
      "tryAgain": "Coba lagi",
      "offline": "Anda sedang offline. Sambungkan saat kembali online.",
      "unavailable": "Kalender & tugas sedang tidak tersedia.",
      "disconnected": "{{provider}} terputus.",
      "google": {
        "name": "Google",
        "sub": "Kalender dan Tugas",
        "what": "Google Calendar dan Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Tugas dan proyek",
        "what": "Todoist"
      },
      "apple": {
        "name": "Kalender & Pengingat",
        "subNative": "Di {{device}} ini",
        "subSafari": "Di aplikasi Rhemn untuk iPhone dan Mac"
      },
      "synced": "Disinkronkan {{when}}",
      "connectedSub": "Tersambung",
      "syncing": "Menyinkronkan…",
      "reconnectSub": "Sambungkan ulang agar sinkronisasi tetap berjalan",
      "errorSub": "Sinkronisasi terakhir belum selesai",
      "pausedSub": "Dijeda · Rhemn Pro berakhir"
    },
    "explainer": {
      "google": {
        "title": "Sambungkan Google Calendar dan Tasks",
        "p1Lead": "Kalendermu, hanya-baca",
        "p1Body": "Rhemn menampilkan acaramu di harimu dan tahu kapan kamu sibuk. Rhemn tidak menyimpannya.",
        "p2Lead": "Google Tasks, dua arah",
        "p2Body": "Daftar yang kamu pilih tetap tersinkron, jadi kamu bisa mencentang tugas di mana saja.",
        "p3Lead": "Bisa dibatalkan kapan saja",
        "p3Body": "Putuskan sambungan kapan saja, di sini atau di Akun Google-mu.",
        "footnote": "Google akan menunjukkan persis apa yang diminta Rhemn."
      },
      "todoist": {
        "title": "Sambungkan Todoist",
        "p1Lead": "Proyekmu, dua arah",
        "p1Body": "Proyek yang kamu pilih tetap tersinkron, jadi kamu bisa mencentang tugas di mana saja.",
        "p2Lead": "Cara pemetaannya",
        "p2Body": "Prioritas Todoist menjadi Kritis, Tinggi, Sedang, dan Rendah. Sub-tugas yang lebih dalam dari satu tingkat ditampilkan sebagai langkah di bawah tugas utamanya.",
        "p3Lead": "Bisa dibatalkan kapan saja",
        "p3Body": "Putuskan sambungan kapan saja, di sini atau di pengaturan Todoist.",
        "cta": "Lanjut ke Todoist",
        "footnote": "Todoist akan meminta konfirmasi."
      },
      "skip": "Nanti saja",
      "cancel": "Batal",
      "waiting": "Menunggu {{provider}}…",
      "safariWaiting": "Selesaikan di tab baru, lalu kembali ke sini.",
      "safariReopen": "Buka tab lagi",
      "denied": "{{provider}} tidak memberikan akses, jadi tidak ada yang tersambung.",
      "error": "Tidak dapat tersambung ke {{provider}}. Coba lagi sebentar lagi."
    },
    "detail": {
      "back_aria": "Kembali ke Kalender & tugas",
      "syncNow": "Sinkronkan sekarang",
      "intro": "Pilih apa yang disinkronkan Rhemn. Anda bisa mengubahnya kapan saja.",
      "taskLists": "Daftar tugas",
      "projects": "Proyek",
      "reminders": "Pengingat",
      "calendars": "Kalender",
      "rhemnCalendarSub": "Waktu salatmu, tidak dihitung sibuk",
      "loading": "Memuat…",
      "loadError": "Daftar Anda tidak dapat dimuat.",
      "emptyGoogle": "Tidak ada daftar tugas di Google Tasks.",
      "emptyTodoist": "Tidak ada proyek di Todoist.",
      "addError": "{{name}} tidak dapat ditambahkan. Coba lagi.",
      "removed": "Dihapus dari Rhemn. Masih ada di {{provider}}.",
      "undo": "Urungkan",
      "prayerTimes": "Tambahkan waktu salat ke kalendermu",
      "prayerTimesSub": "Menambahkan lima waktu salat ke kalender bernama Rhemn, untuk 7 hari ke depan, agar tidak ada yang menjadwalkan di atasnya.",
      "prayerTimesOn": "Aktif. Ditambahkan hingga {{date}}.",
      "prayerTimesWaiting": "Menunggu Google…",
      "prayerTimesDenied": "Google tidak mengizinkannya. Tidak ada yang ditambahkan.",
      "prayerTimesRemoveAsk": "Hapus waktu salat Rhemn dari kalendermu?",
      "prayerTimesKeep": "Pertahankan",
      "prayerTimesRemove": "Hapus",
      "meetingPrompts": "Pengingat rapat",
      "meetingPromptsSub": "Saat rapat berlink akan segera dimulai, tawarkan untuk mencatat.",
      "busyFootnote": "Rencanakan hari saya hanya melihat kapan kamu sibuk, tidak pernah isi rapatmu.",
      "todoistFootnote": "Prioritas Todoist menjadi Kritis, Tinggi, Sedang, dan Rendah. Sub-tugas yang lebih dalam dari satu tingkat ditampilkan sebagai langkah di bawah tugas utamanya.",
      "reauth": "{{provider}} berhenti mengizinkan Rhemn menyinkronkan. Ini terjadi saat akses dicabut atau kata sandimu berubah.",
      "reconnect": "Sambungkan ulang",
      "paused": "Sinkronisasi dijeda karena Rhemn Pro berakhir. Daftar Anda tetap seperti semula.",
      "calendarDenied": "Akses kalender nonaktif.",
      "remindersDenied": "Akses pengingat nonaktif.",
      "disconnect": "Putuskan {{provider}}",
      "disconnectTitle": "Putuskan {{provider}}?",
      "disconnectBody": "Tidak ada yang dihapus di {{provider}}.",
      "disconnectRhemnCal": "Kalender waktu salat Rhemn Anda akan dihapus dari Google Calendar.",
      "disconnectError": "Tidak dapat memutuskan {{provider}}. Coba lagi sebentar lagi.",
      "keepLists": "Simpan daftar saya di Rhemn",
      "keepListsSub": "Sinkronisasinya berhenti dan menjadi daftar Rhemn biasa.",
      "removeLists": "Hapus dari Rhemn",
      "removeListsSub": "Hanya salinan di Rhemn yang dihapus.",
      "disconnecting": "Memutuskan…",
      "appleStop": "Berhenti menggunakan Kalender & Pengingat",
      "appleStopTitle": "Berhenti menggunakan Kalender & Pengingat?",
      "appleStopBody": "Rhemn berhenti menampilkan acara dan pengingat Anda. Untuk menghapus aksesnya sepenuhnya, matikan di Pengaturan.",
      "justNow": "baru saja",
      "tasksScope": "Rhemn perlu izin untuk melihat Google Tasks Anda. Sambungkan ulang lalu centang Tasks untuk mengizinkannya.",
      "calendarsLoadError": "Tidak dapat memuat kalender Anda.",
      "calendarsEmpty": "Tidak ada kalender di akun ini.",
      "calendarsScope": "Rhemn perlu izin untuk melihat Google Calendar Anda. Sambungkan ulang dan centang Calendar untuk mengizinkannya.",
      "prayerTimesError": "Tidak dapat menambahkan waktu salat Anda. Coba lagi sebentar lagi.",
      "remindersEmpty": "Tidak ada daftar di Pengingat.",
      "openSettings": "Buka Pengaturan",
      "appleStopCta": "Berhenti menggunakan"
    },
    "locked": {
      "body": "Lihat rapatmu di dalam blok salatmu, dan jaga Google Tasks tetap sinkron dengan Rhemn.",
      "googleName": "Google Calendar & Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "perangkat"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, tersinkron dengan {{provider}}",
      "unlinkConfirm": "Hapus “{{name}}” dari Rhemn? Tetap ada di {{provider}}.",
      "remove": "Hapus",
      "offline": "Offline · Perubahan akan tersinkron ke {{provider}} saat Anda kembali online.",
      "stillSyncing": "Masih menyinkronkan dengan {{provider}}…",
      "failed_other": "{{count}} perubahan tidak sampai ke {{provider}}.",
      "retry": "Coba lagi",
      "needsReconnect": "{{provider}} perlu Anda sambungkan ulang.",
      "paused": "Sinkronisasi dijeda · Rhemn Pro berakhir.",
      "upgrade": "Tingkatkan",
      "notSynced": "Belum tersinkron",
      "notSynced_aria": "Belum tersinkron ke {{provider}}. Coba lagi.",
      "remindersOff": "Rhemn tidak dapat mengakses Pengingat. Aktifkan lagi di Pengaturan.",
      "dueToday": "Hari ini",
      "dueTomorrow": "Besok",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Sepanjang hari",
      "more": "+{{count}}",
      "more_aria": "Tampilkan {{count}} acara sepanjang hari lainnya",
      "less_aria": "Tampilkan lebih sedikit acara sepanjang hari",
      "events_aria": "Acara",
      "event_aria": "{{start}} sampai {{end}}, {{title}}",
      "allDayEvent_aria": "Sepanjang hari, {{title}}",
      "untitled": "Sibuk",
      "now": "Sekarang · hingga {{end}}",
      "until": "hingga {{end}}",
      "into": "· hingga {{prayer}}",
      "loadError": "Tidak dapat memuat kalender Anda.",
      "needsReconnect": "Google Calendar perlu Anda sambungkan ulang.",
      "scope": "Rhemn tidak dapat melihat Google Calendar Anda. Sambungkan ulang dan centang Calendar untuk mengizinkannya.",
      "appleOff": "Rhemn tidak dapat melihat kalender Anda. Aktifkan kembali di Pengaturan."
    },
    "plan": {
      "mostlyMeetings": "Sebagian besar rapat · {{duration}} luang",
      "noFreeTime": "Tidak ada waktu luang",
      "aroundMeetings_other": "Direncanakan di sekitar {{count}} rapat.",
      "settledBusy": "Semuanya sudah pas di sela rapat Anda."
    },
    "meeting": {
      "group_aria": "Rapat akan dimulai",
      "now": "sekarang",
      "takeNotes": "Buat catatan",
      "takeNotes_aria": "Buat catatan untuk {{title}}",
      "dismiss_aria": "Tutup",
      "announce": "{{title}} dimulai {{when}}.",
      "announceNow": "{{title}} dimulai sekarang.",
      "yourMeeting": "Rapat Anda"
    },
    "apple": {
      "primer": {
        "title": "Tampilkan kalender di samping waktu salat",
        "body": "Rhemn membaca acara dan pengingat di {{device}} ini untuk menempatkannya dalam hari Anda. Semuanya tetap di perangkat Anda. Rencanakan hari saya hanya memakai waktu saat Anda sibuk.",
        "cta": "Lanjutkan",
        "skip": "Nanti saja",
        "footnote": "{{device}} akan meminta izin dua kali, sekali untuk Kalender dan sekali untuk Pengingat. Anda dapat mengubah keduanya di Pengaturan."
      }
    }
  }
}
